module.exports = __webpack_public_path__ + "img/milkBlush2.8f924180.jpg";